import request from '@/router/axios';
//查询角色列表(带分页)
export const saveOrUpdateSimulationPanelTemplate = (data) => {
  return request({
    url: '/svolt-ess-boss-service/simulation/saveOrUpdateSimulationPanelTemplate',
    method: 'post',
    data: data
  })
}
//查询全部模版
export const searchAllSimulationPanelTemplateById = (data) => {
  return request({
    url: '/svolt-ess-boss-service/simulation/searchAllSimulationPanelTemplateById',
    method: 'post',
    data: data
  })
}
//根据编号查询模版
export const searchSimulationPanelTemplateById = (data) => {
  return request({
    url: '/svolt-ess-boss-service/simulation/searchSimulationPanelTemplateById',
    method: 'post',
    params: data
  })
}
//获取待绑定数据点
export const searchAllEms = (data) => {
  return request({
    url: '/svolt-ess-boss-service/simulation/searchAllEms',
    method: 'post',
    data: data
  })
}
//新增或修改绑点数据配置
export const saveOrUpdateSimulationPanelData = (data) => {
  return request({
    url: '/svolt-ess-boss-service/simulation/saveOrUpdateSimulationPanelData',
    method: 'post',
    data: data
  })
}
//查询面板和数据点
export const searchFixSimulationPanelData = (data) => {
  return request({
    url: '/svolt-ess-boss-service/simulation/searchFixSimulationPanelData',
    method: 'post',
    data: data
  })
}
//模型列表
export const searchSimulationModelList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/simulation/searchSimulationModelList',
    method: 'get',
    params: data
  })
}
//新增仿真模型
export const addSimulationModel = (data) => {
  return request({
    url: '/svolt-ess-boss-service/simulation/addSimulationModel',
    method: 'post',
    data: data
  })
}

//修改仿真模型
export const updateSimulationModel = (data) => {
  return request({
    url: '/svolt-ess-boss-service/simulation/updateSimulationModel',
    method: 'post',
    data: data
  })
}
//删除仿真模型
export const deleteSimulationModel = (data) => {
  return request({
    url: '/svolt-ess-boss-service/simulation/deleteSimulationModel',
    method: 'post',
    data: data
  })
}
//查询项目下仿真设备列表
export const searchSimulationEquipments = (data) => {
  return request({
    url: '/svolt-ess-boss-service/simulationV2/searchSimulationEquipments',
    method: 'post',
    data: data
  })
}
//新增仿真设备
export const addSimulationEquipment = (data) => {
  return request({
    url: '/svolt-ess-boss-service/simulationV2/addSimulationEquipment',
    method: 'post',
    data: data
  })
}
//删除仿真设备
export const deleteSimulationEquipment = (data) => {
  return request({
    url: '/svolt-ess-boss-service/simulationV2/deleteSimulationEquipment',
    method: 'post',
    data: data
  })
}

//根据组合编号和项目编号查询面板以及绑点配置
export const searchSimulationPanelData = (data) => {
  return request({
    url: '/svolt-ess-boss-service/simulation/searchSimulationPanelData',
    method: 'post',
    params: data
  })
}
//模糊查询绑点数据top10
export const fuzzySearchFields = (data) => {
  return request({
    url: '/svolt-ess-boss-service/simulation/fuzzySearchFields',
    method: 'post',
    params: data
  })
}

//
export const deleteSimulationPanelTemplateById = (data) => {
  return request({
    url: '/svolt-ess-boss-service/simulation/deleteSimulationPanelDataById',
    method: 'post',
    params: data
  })
}

//项目下-查询sn列表
export const searchEmsList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/simulation/searchEmsList',
    method: 'post',
    data: data
  })
}

//查询项目EMS下簇列表
export const searchCluListBySn = (data) => {
  return request({
    url: '/svolt-ess-boss-service/simulation/searchCluListBySn',
    method: 'post',
    data: data
  })
}
//项目下-查询项目下堆列表
export const searchStackList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/simulationV2/searchStackList',
    method: 'post',
    data: data
  })
}
//项目下-修改仿真设备
export const updateSimulationEquipment = (data) => {
  return request({
    url: '/svolt-ess-boss-service/simulationV2/updateSimulationEquipment',
    method: 'post',
    data: data
  })
}

export default{
  saveOrUpdateSimulationPanelTemplate,
  searchAllSimulationPanelTemplateById,
  searchSimulationPanelTemplateById,
  searchAllEms,
  saveOrUpdateSimulationPanelData,
  searchSimulationPanelData,
  searchFixSimulationPanelData,
  searchSimulationModelList,
  addSimulationModel,
  updateSimulationModel,
  deleteSimulationModel,
  searchSimulationEquipments,
  addSimulationEquipment,
  deleteSimulationEquipment,
  fuzzySearchFields,
  deleteSimulationPanelTemplateById,
  searchEmsList,
  searchCluListBySn,
  searchStackList,
  updateSimulationEquipment
}



// WEBPACK FOOTER //
// ./src/api/glconfig.js